import { PaginationType, onPaginationButtonClick } from './on-pagination-button-click';
import { getCurrentPageNumber } from './get-current-page-number';
import { getLastPageNumber } from './get-last-page-number';
import { enableOrDisablePaginationButtons } from './enable-or-disable-pagination-buttons';

export function initializePagination(listWrapperRootElement: HTMLElement) {
    enableOrDisablePaginationButtons(getCurrentPageNumber(listWrapperRootElement), listWrapperRootElement);
    registerPaginationButtonClickListeners(listWrapperRootElement);
}

function registerPaginationButtonClickListeners(listWrapperRootElement: HTMLElement) {
    registerFirstPageButtonClickListener(listWrapperRootElement);
    registerPreviousPageButtonClickListener(listWrapperRootElement);
    registerNextPageButtonClickListener(listWrapperRootElement);
    registerLastPageButtonClickListener(listWrapperRootElement);
}

function registerFirstPageButtonClickListener(listWrapperRootElement: HTMLElement) {
    const firstPageButtonElement = findFirstPageButtonElement(listWrapperRootElement);
    firstPageButtonElement?.addEventListener('click', () => onPaginationButtonClick(1, listWrapperRootElement, PaginationType.FIRST));
}

function registerPreviousPageButtonClickListener(listWrapperRootElement: HTMLElement) {
    const previousPageButtonElement = findPreviousPageButtonElement(listWrapperRootElement);
    previousPageButtonElement?.addEventListener('click', () => {
        const newPageNumber = getCurrentPageNumber(listWrapperRootElement) - 1;
        onPaginationButtonClick(newPageNumber, listWrapperRootElement, PaginationType.PREVIOUS);
    });
}

function registerNextPageButtonClickListener(listWrapperRootElement: HTMLElement) {
    const previousPageButtonElement = findNextPageButtonElement(listWrapperRootElement);
    previousPageButtonElement?.addEventListener('click', () => {
        const newPageNumber = getCurrentPageNumber(listWrapperRootElement) + 1;
        onPaginationButtonClick(newPageNumber, listWrapperRootElement, PaginationType.NEXT);
    });
}

function registerLastPageButtonClickListener(listWrapperRootElement: HTMLElement) {
    const previousPageButtonElement = findLastPageButtonElement(listWrapperRootElement);
    previousPageButtonElement?.addEventListener('click', () => {
        const lastPageNumber = getLastPageNumber(listWrapperRootElement);
        onPaginationButtonClick(lastPageNumber, listWrapperRootElement, PaginationType.LAST);
    });
}

function findFirstPageButtonElement(listWrapperRootElement: HTMLElement) {
    return listWrapperRootElement.querySelector<HTMLElement>('.js_cr_list-wrapper__pagination-button-first');
}

function findPreviousPageButtonElement(listWrapperRootElement: HTMLElement) {
    return listWrapperRootElement.querySelector<HTMLElement>('.js_cr_list-wrapper__pagination-button-previous');
}

function findNextPageButtonElement(listWrapperRootElement: HTMLElement) {
    return listWrapperRootElement.querySelector<HTMLElement>('.js_cr_list-wrapper__pagination-button-next');
}

function findLastPageButtonElement(listWrapperRootElement: HTMLElement) {
    return listWrapperRootElement.querySelector<HTMLElement>('.js_cr_list-wrapper__pagination-button-last');
}
